export class PrinterService {
  iframe = null;

  constructor(body) {
    this.iframe = document.createElement('iframe');
    this.iframe.srcdoc = body;

    if (localStorage.getItem('openHTMLManifest') === 'true') {
      const win = window.open();
      win.document.write(body);
    }

    this.iframe.setAttribute('allowfullscreen', 'true');

    document.body.appendChild(this.iframe);

    this.iframe.onload = () => {
      requestAnimationFrame(() => {
        this.iframe.contentWindow.focus();
        this.iframe.contentWindow.print();
      });
    };

    this.iframe.contentWindow.addEventListener('afterprint', this.destroy);
  }

  destroy = () => {
    this.iframe.contentWindow.removeEventListener('afterprint', this.destroy);
    document.body.removeChild(this.iframe);
    this.iframe = null;
    window.focus();
  };

  static async print(cb) {
    new PrinterService(await cb());
  }
}
